
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { ProcurementFormValues } from "../schema";
import { ProductDropdown } from "./ProductDropdown";

interface ItemFormFieldsProps {
  form: UseFormReturn<ProcurementFormValues>;
  index: number;
  item: any;
}

export const ItemFormFields = ({ form, index, item }: ItemFormFieldsProps) => {
  const handleWheelEvent = (e: React.WheelEvent) => {
    e.preventDefault();
  };

  const handleNumberChange = (field: any, value: string, fieldName: string) => {
    const numValue = parseFloat(value) || 0;
    field.onChange(numValue);
    
    // Trigger form validation and force re-calculation
    form.trigger(fieldName as keyof ProcurementFormValues);
    
    // Force a form state update to ensure watchers are notified
    setTimeout(() => {
      form.trigger();
    }, 0);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ProductDropdown
          form={form}
          index={index}
          label="Product Name"
          placeholder="Select a product..."
        />

        <FormField
          control={form.control}
          name={`items.${index}.quantity` as const}
          render={({ field }) => {
            const unitOfMeasure = item?.unit_of_measure || 'kg';
            return (
            <FormItem>
              <FormLabel>Quantity ({unitOfMeasure})</FormLabel>
              <FormControl>
                <Input
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0"
                  className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
                  onWheel={handleWheelEvent}
                  {...field}
                  onChange={e => handleNumberChange(field, e.target.value, `items.${index}.quantity`)}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );}}
        />

        <FormField
          control={form.control}
          name={`items.${index}.price_per_unit`}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Price per Unit (Br)</FormLabel>
              <FormControl>
                <Input
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
                  onWheel={handleWheelEvent}
                  {...field}
                  onChange={e => handleNumberChange(field, e.target.value, `items.${index}.price_per_unit`)}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name={`items.${index}.quality_grade`}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Quality Grade</FormLabel>
              <FormControl>
                <Input placeholder="e.g., Grade A, Premium" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name={`items.${index}.notes`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Notes</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Additional notes for this product..."
                className="min-h-[60px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="bg-muted p-3 rounded-md">
        <div className="text-sm font-medium">
          Item Total: Br {(item?.price_per_unit * item?.quantity || 0).toFixed(2)}
        </div>
      </div>
    </div>
  );
};
